export const dataLibS = [{
  word: 'souwi',
  partOfSpeech: 'N',
  definition: ['mouse'],
  egSentenceKw: 'Chat-la kouwi dèyè souwi-a.',
  egSentenceEn: 'The cat chased the mouse.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. souris]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'soulyé',
  partOfSpeech: 'N',
  definition: ['shoe'],
  egSentenceKw: 'I ka pòté soulyé nwè.',
  egSentenceEn: 'He\'s wearing black shoes.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. soulier]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sanng',
  partOfSpeech: 'N',
  definition: ['belt'],
  egSentenceKw: 'Sanng-lan té twò gwo pou wen\'y.',
  egSentenceEn: 'The belt was too large for his waist.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sèvyèt',
  partOfSpeech: 'N',
  definition: ['towel'],
  egSentenceKw: 'Ba li on sèvyèt pou i swiyé bouch li.',
  egSentenceEn: 'Give him a towel to wipe his mouth.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. serviette]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sak',
  partOfSpeech: 'N',
  definition: ['bag', 'sack'],
  egSentenceKw: 'Mwen vlé on sak sik.',
  egSentenceEn: 'I want a bag of sugar.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. sac]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sé',
  partOfSpeech: 'V',
  definition: ['to be'],
  egSentenceKw: 'Fwè mwen sé on dòktè.',
  egSentenceEn: 'My brother\'s a doctor.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. c\'est]',
  dialect: '🇱🇨',
  variant: 'yé',
}, {
  word: 'sé',
  partOfSpeech: null,
  definition: ['pluralizer'],
  egSentenceKw: 'Sé wòb sala bèl pasé sé lézòt-la.',
  egSentenceEn: 'These dresses are prettier than the others.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sésé',
  partOfSpeech: 'N',
  definition: ['sister'],
  egSentenceKw: 'Sésé mwen ka twavay an lopital-la.',
  egSentenceEn: 'My sister works at the hospital.',
  synonym: ['sè'],
  antonym: ['fwè'],

  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sé',
  partOfSpeech: 'N',
  definition: ['sister'],
  egSentenceKw: 'Sé moun sala sé fwè èk sè mwen an Jézi.',
  egSentenceEn: 'Those people are my brothers and sisters in Jesus.',
  synonym: ['sésé'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sala',
  partOfSpeech: 'ADJ',
  definition: ['this', 'that'],
  egSentenceKw: 'Nou kontan motoka sala.',
  egSentenceEn: 'We like that car.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. cela]',
  dialect: '🇱🇨',
  variant: 'sa\'a',
}, {
  word: 'sa',
  partOfSpeech: 'PRO',
  definition: ['this', 'that', '(demonstrative pronoun)'],
  egSentenceKw: 'Ès ou kopwann sa?',
  egSentenceEn: 'Do you understand that?',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. ça]',
  dialect: '🇱🇨',
  variant: 'san',
}, {
  word: 'sann',
  partOfSpeech: 'N',
  definition: ['ashes'],
  egSentenceKw: 'Sa ou pèd an difé ou pé twouvé\'y adan sann.',
  egSentenceEn: 'What you lose in the fire you may find in the ashes.',
  synonym: ['gwi'],
  antonym: [null],
  etymology: '[< Fr. cendre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sann',
  partOfSpeech: 'N',
  definition: ['ashes'],
  egSentenceKw: 'Sa ou pèd an difé ou pé twouvé\'y adan sann.',
  egSentenceEn: 'What you lose in the fire you may find in the ashes.',
  synonym: ['gwi'],
  antonym: [null],
  etymology: '[< Fr. cendre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sann',
  partOfSpeech: 'N',
  definition: ['grey'],
  egSentenceKw: 'Wòb li té sann.',
  egSentenceEn: 'Her dress was grey.',
  synonym: ['gwi'],
  antonym: [null],
  etymology: '[< Fr. cendre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sòlèy',
  partOfSpeech: 'N',
  definition: ['sun'],
  egSentenceKw: 'Sòlèy-la ka kouché bonnè sé jou sala.',
  egSentenceEn: 'The sun sets early these days.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. soleil]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sou',
  partOfSpeech: 'ADJ',
  definition: ['drunk'],
  egSentenceKw: 'Nonm sala toujou sou.',
  egSentenceEn: 'That man is always drunk.',
  synonym: [null],
  antonym: ['natiwèl'],
  etymology: '[< Fr. saoul]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sayd',
  partOfSpeech: 'N',
  definition: ['side'],
  egSentenceKw: 'I té lòt sayd-la.',
  egSentenceEn: 'He was on the other side.',
  synonym: ['bò', 'fasad', 'koté'],
  antonym: [null],
  etymology: '[< Eng. side]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sentdjòn',
  partOfSpeech: 'N',
  definition: ['plant with a red flower used in bush medicine'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. Saint John]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'slak',
  partOfSpeech: 'N',
  definition: ['loose'],
  egSentenceKw: 'Sanng-lan mawé twò slak.',
  egSentenceEn: 'The belt was tied too loose.',
  synonym: [null],
  antonym: ['séwé'],
  etymology: '[< Eng. slack]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'stéchann',
  partOfSpeech: 'N',
  definition: ['police station'],
  egSentenceKw: 'Désann an bout chimen-an épi ou kay wè stéchann-an.',
  egSentenceEn: 'Go down to the end of the road and you will see the police station.',
  synonym: ['kòdgad'],
  antonym: [null],
  etymology: '[< Eng. station]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'swing',
  partOfSpeech: 'N',
  definition: ['swing'],
  egSentenceKw: 'Las pwan swing asou bwanch-lan avan i kasé.',
  egSentenceEn: 'Quit swinging on the branch or it will break.',
  synonym: ['balanswin'],
  antonym: [null],
  etymology: '[< Eng. swing]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'switi',
  partOfSpeech: 'N',
  definition: ['candy'],
  egSentenceKw: 'I niché switi-a.',
  egSentenceEn: 'He licked the candy.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. sweetie]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'swè',
  partOfSpeech: 'N',
  definition: ['evening', 'night'],
  egSentenceKw: 'I ka vini lé swè.',
  egSentenceEn: 'He comes in the evening.',
  synonym: [null],
  antonym: ['jou'],
  etymology: '[< Fr. soir]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'san',
  partOfSpeech: 'PREP',
  definition: ['without'],
  egSentenceKw: 'Nou wété twa jou san manjé.',
  egSentenceEn: 'We stayed three days without food.',
  synonym: [null],
  antonym: ['épi', 'èvèk'],
  etymology: '[< Fr. sans]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'silon',
  partOfSpeech: 'PREP',
  definition: ['according to'],
  egSentenceKw: 'Silon Tòti, Chat ka pasé pa tè.',
  egSentenceEn: 'According to Turtle, Cat is going on the ground.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. selon]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sikwiyé',
  partOfSpeech: 'N',
  definition: ['bananaquit', '(Coereba flaveola)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sizo',
  partOfSpeech: 'N',
  definition: ['Magnificent Fregate bird', '(Fregata magnificens)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. ciseaux]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'si',
  partOfSpeech: 'CONJ',
  definition: ['if'],
  egSentenceKw: 'Nou kay alé si ou vlé.',
  egSentenceEn: 'We will go if you want.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. si]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'si',
  partOfSpeech: 'ADJ',
  definition: ['sour'],
  egSentenceKw: 'Zowanj-lan si kon siton.',
  egSentenceEn: 'The orange was as sour as a lime.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. sur]',
  dialect: '🇱🇨',
  variant: [null],
},
];
